import { Verb } from '../types';

export const verbs: Verb[] = [
  { infinitive: 'être', english: 'to be', group: 3 },
  { infinitive: 'avoir', english: 'to have', group: 3 },
  { infinitive: 'aller', english: 'to go', group: 3 },
  { infinitive: 'faire', english: 'to do/make', group: 3 },
  { infinitive: 'dire', english: 'to say', group: 3 },
  { infinitive: 'venir', english: 'to come', group: 3 },
  { infinitive: 'voir', english: 'to see', group: 3 },
  { infinitive: 'savoir', english: 'to know', group: 3 },
  { infinitive: 'pouvoir', english: 'to be able to', group: 3 },
  { infinitive: 'vouloir', english: 'to want', group: 3 },
  { infinitive: 'parler', english: 'to speak', group: 1 },
  { infinitive: 'manger', english: 'to eat', group: 1 },
  { infinitive: 'aimer', english: 'to like/love', group: 1 },
  { infinitive: 'donner', english: 'to give', group: 1 },
  { infinitive: 'trouver', english: 'to find', group: 1 },
  { infinitive: 'finir', english: 'to finish', group: 2 },
  { infinitive: 'choisir', english: 'to choose', group: 2 },
  { infinitive: 'réfléchir', english: 'to think/reflect', group: 2 },
  { infinitive: 'réussir', english: 'to succeed', group: 2 },
  { infinitive: 'grandir', english: 'to grow', group: 2 },
  
  // Batch 1: Additional verbs
  { infinitive: 'prendre', english: 'to take', group: 3 },
  { infinitive: 'mettre', english: 'to put', group: 3 },
  { infinitive: 'comprendre', english: 'to understand', group: 3 },
  { infinitive: 'écrire', english: 'to write', group: 3 },
  { infinitive: 'lire', english: 'to read', group: 3 },
  { infinitive: 'jouer', english: 'to play', group: 1 },
  { infinitive: 'regarder', english: 'to watch/look at', group: 1 },
  { infinitive: 'écouter', english: 'to listen to', group: 1 },
  { infinitive: 'chanter', english: 'to sing', group: 1 },
  { infinitive: 'agir', english: 'to act', group: 2 },
  
  // Batch 2: Additional verbs
  { infinitive: 'sortir', english: 'to go out', group: 3 },
  { infinitive: 'partir', english: 'to leave', group: 3 },
  { infinitive: 'dormir', english: 'to sleep', group: 3 },
  { infinitive: 'ouvrir', english: 'to open', group: 3 },
  { infinitive: 'offrir', english: 'to offer', group: 3 },
  { infinitive: 'marcher', english: 'to walk', group: 1 },
  { infinitive: 'chercher', english: 'to look for', group: 1 },
  { infinitive: 'penser', english: 'to think', group: 1 },
  { infinitive: 'demander', english: 'to ask', group: 1 },
  { infinitive: 'répondre', english: 'to answer', group: 3 },
  
  // Batch 3: Additional verbs
  { infinitive: 'vendre', english: 'to sell', group: 3 },
  { infinitive: 'perdre', english: 'to lose', group: 3 },
  { infinitive: 'attendre', english: 'to wait', group: 3 },
  { infinitive: 'entendre', english: 'to hear', group: 3 },
  { infinitive: 'descendre', english: 'to go down', group: 3 },
  { infinitive: 'arriver', english: 'to arrive', group: 1 },
  { infinitive: 'tomber', english: 'to fall', group: 1 },
  { infinitive: 'monter', english: 'to go up', group: 1 },
  { infinitive: 'rester', english: 'to stay', group: 1 },
  { infinitive: 'sentir', english: 'to feel/smell', group: 3 },
  
  // Batch 4: Additional verbs
  { infinitive: 'croire', english: 'to believe', group: 3 },
  { infinitive: 'devoir', english: 'to have to/must', group: 3 },
  { infinitive: 'recevoir', english: 'to receive', group: 3 },
  { infinitive: 'boire', english: 'to drink', group: 3 },
  { infinitive: 'connaître', english: 'to know (be familiar with)', group: 3 },
  { infinitive: 'vivre', english: 'to live', group: 3 },
  { infinitive: 'suivre', english: 'to follow', group: 3 },
  { infinitive: 'envoyer', english: 'to send', group: 1 },
  { infinitive: 'appeler', english: 'to call', group: 1 },
  { infinitive: 'jeter', english: 'to throw', group: 1 },
  
  // Batch 5: Additional verbs
  { infinitive: 'acheter', english: 'to buy', group: 1 },
  { infinitive: 'commencer', english: 'to begin/start', group: 1 },
  { infinitive: 'payer', english: 'to pay', group: 1 },
  { infinitive: 'essayer', english: 'to try', group: 1 },
  { infinitive: 'préférer', english: 'to prefer', group: 1 },
  { infinitive: 'espérer', english: 'to hope', group: 1 },
  { infinitive: 'répéter', english: 'to repeat', group: 1 },
  { infinitive: 'protéger', english: 'to protect', group: 1 },
  { infinitive: 'célébrer', english: 'to celebrate', group: 1 },
  { infinitive: 'considérer', english: 'to consider', group: 1 },
  
  // Batch 6: Additional verbs
  { infinitive: 'courir', english: 'to run', group: 3 },
  { infinitive: 'mourir', english: 'to die', group: 3 },
  { infinitive: 'tenir', english: 'to hold', group: 3 },
  { infinitive: 'obtenir', english: 'to obtain/get', group: 3 },
  { infinitive: 'devenir', english: 'to become', group: 3 },
  { infinitive: 'revenir', english: 'to come back', group: 3 },
  { infinitive: 'se souvenir', english: 'to remember', group: 3 },
  { infinitive: 'appartenir', english: 'to belong', group: 3 },
  { infinitive: 'maintenir', english: 'to maintain', group: 3 },
  { infinitive: 'contenir', english: 'to contain', group: 3 },
  
  // Batch 7: Additional verbs
  { infinitive: 'rendre', english: 'to return/give back', group: 3 },
  { infinitive: 'apprendre', english: 'to learn', group: 3 },
  { infinitive: 'surprendre', english: 'to surprise', group: 3 },
  { infinitive: 'craindre', english: 'to fear', group: 3 },
  { infinitive: 'peindre', english: 'to paint', group: 3 },
  { infinitive: 'joindre', english: 'to join', group: 3 },
  { infinitive: 'atteindre', english: 'to reach/achieve', group: 3 },
  { infinitive: 'éteindre', english: 'to extinguish', group: 3 },
  { infinitive: 'plaindre', english: 'to pity', group: 3 },
  { infinitive: 'rejoindre', english: 'to rejoin/meet up with', group: 3 },
  
  // Batch 8: Additional verbs
  { infinitive: 'paraître', english: 'to seem/appear', group: 3 },
  { infinitive: 'disparaître', english: 'to disappear', group: 3 },
  { infinitive: 'reconnaître', english: 'to recognize', group: 3 },
  { infinitive: 'naître', english: 'to be born', group: 3 },
  { infinitive: 'croître', english: 'to grow/increase', group: 3 },
  { infinitive: 'apparaître', english: 'to appear', group: 3 },
  { infinitive: 'construire', english: 'to build', group: 3 },
  { infinitive: 'conduire', english: 'to drive/lead', group: 3 },
  { infinitive: 'traduire', english: 'to translate', group: 3 },
  
  // Batch 9: Additional verbs
  { infinitive: 'produire', english: 'to produce', group: 3 },
  { infinitive: 'introduire', english: 'to introduce', group: 3 },
  { infinitive: 'séduire', english: 'to seduce', group: 3 },
  { infinitive: 'détruire', english: 'to destroy', group: 3 },
  { infinitive: 'cuire', english: 'to cook', group: 3 },
  { infinitive: 'nuire', english: 'to harm', group: 3 },
  { infinitive: 'plaire', english: 'to please', group: 3 },
  { infinitive: 'taire', english: 'to keep quiet', group: 3 },
  { infinitive: 'pleuvoir', english: 'to rain', group: 3 },
  { infinitive: 'falloir', english: 'to be necessary', group: 3 },
  
  // Batch 10: Additional verbs
  { infinitive: 'se laver', english: 'to wash oneself', group: 1 },
  { infinitive: 'se lever', english: 'to get up', group: 1 },
  { infinitive: 'se coucher', english: 'to go to bed', group: 1 },
  { infinitive: "s'habiller", english: 'to get dressed', group: 1 },
  { infinitive: 'se réveiller', english: 'to wake up', group: 1 },
  { infinitive: 'se dépêcher', english: 'to hurry', group: 1 },
  { infinitive: 'se promener', english: 'to take a walk', group: 1 },
  { infinitive: "s'amuser", english: 'to have fun', group: 1 },
  { infinitive: 'se reposer', english: 'to rest', group: 1 },
  { infinitive: "s'appeler", english: 'to be called/named', group: 1 },
  
  // Batch 11: Additional verbs
  { infinitive: 'nager', english: 'to swim', group: 1 },
  { infinitive: 'voyager', english: 'to travel', group: 1 },
  { infinitive: 'partager', english: 'to share', group: 1 },
  { infinitive: 'changer', english: 'to change', group: 1 },
  { infinitive: 'bouger', english: 'to move', group: 1 },
  { infinitive: 'ranger', english: 'to tidy up', group: 1 },
  { infinitive: 'juger', english: 'to judge', group: 1 },
  { infinitive: 'obliger', english: 'to oblige/force', group: 1 },
  { infinitive: 'plonger', english: 'to dive', group: 1 },
  
  // Batch 12: Additional verbs
  { infinitive: 'servir', english: 'to serve', group: 2 },
  { infinitive: 'mentir', english: 'to lie', group: 3 },
  { infinitive: 'souffrir', english: 'to suffer', group: 3 },
  { infinitive: 'couvrir', english: 'to cover', group: 3 },
  { infinitive: 'découvrir', english: 'to discover', group: 3 },
  { infinitive: 'cueillir', english: 'to pick (flowers, fruit)', group: 3 },
  { infinitive: 'accueillir', english: 'to welcome', group: 3 },
  { infinitive: 'recueillir', english: 'to collect/gather', group: 3 },
  { infinitive: 'faillir', english: 'to almost do something', group: 3 },
  { infinitive: 'assaillir', english: 'to assault/attack', group: 3 },
  
  // Batch 13: Final verbs
  { infinitive: 'abandonner', english: 'to abandon', group: 1 },
  { infinitive: 'accepter', english: 'to accept', group: 1 },
  { infinitive: 'accompagner', english: 'to accompany', group: 1 },
  { infinitive: 'adorer', english: 'to adore', group: 1 },
  { infinitive: 'annoncer', english: 'to announce', group: 1 },
  { infinitive: 'apporter', english: 'to bring', group: 1 },
  { infinitive: 'arrêter', english: 'to stop', group: 1 },
  { infinitive: 'augmenter', english: 'to increase', group: 1 },
  { infinitive: 'baisser', english: 'to lower', group: 1 },
  { infinitive: 'casser', english: 'to break', group: 1 },
  { infinitive: 'cesser', english: 'to cease', group: 1 },
  { infinitive: 'continuer', english: 'to continue', group: 1 },
  { infinitive: 'créer', english: 'to create', group: 1 },
  { infinitive: 'danser', english: 'to dance', group: 1 },
  { infinitive: 'décider', english: 'to decide', group: 1 },
  { infinitive: 'désirer', english: 'to desire', group: 1 },
  { infinitive: 'détester', english: 'to hate', group: 1 },
  { infinitive: 'développer', english: 'to develop', group: 1 },
  { infinitive: 'discuter', english: 'to discuss', group: 1 },
  { infinitive: 'douter', english: 'to doubt', group: 1 },
];
